import { render, staticRenderFns } from "./SettingEdit.vue?vue&type=template&id=87f98afc&scoped=true&"
import script from "./SettingEdit.vue?vue&type=script&lang=js&"
export * from "./SettingEdit.vue?vue&type=script&lang=js&"
import style0 from "./SettingEdit.vue?vue&type=style&index=0&id=87f98afc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f98afc",
  null
  
)

export default component.exports